import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ArtifactDigest,
  ArtifactFact,
  ArtifactReference,
} from '../types/artifact-digest-types';
import { ProviderMention } from '../types/treatment-types';
import { baseQueryWithErrorHandling } from './baseQuery';

export const artifactDigestApiClient = createApi({
  reducerPath: 'artifactDigestApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['ArtifactDigests'] as const,
  endpoints: (builder) => ({
    getArtifactDigest: builder.query<ArtifactDigest, string>({
      query: (artifactId) => `api/artifacts/${artifactId}/digest/`,
      providesTags: (result, error, artifactId) => [
        { type: 'ArtifactDigests', id: artifactId },
      ],
    }),
    regenerateArtifactDigest: builder.mutation<void, string>({
      query: (artifactId) => ({
        url: `api/artifacts/${artifactId}/digest/regenerate/`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, artifactId) => [
        { type: 'ArtifactDigests', id: artifactId },
      ],
    }),
    getArtifactFacts: builder.query<ArtifactFact[], string>({
      query: (artifactId) => `api/artifacts/${artifactId}/facts/`,
      providesTags: (result, error, artifactId) => [
        { type: 'ArtifactDigests', id: artifactId },
      ],
    }),
    getMentionedProviders: builder.query<ProviderMention[], string>({
      query: (artifactId) => `api/artifacts/${artifactId}/named-entities/`,
      providesTags: (result, error, artifactId) => [
        { type: 'ArtifactDigests', id: artifactId },
      ],
    }),
    getArtifactReferences: builder.query<ArtifactReference[], string>({
      query: (artifactId) => `api/artifacts/${artifactId}/references/`,
      providesTags: (result, error, artifactId) => [
        { type: 'ArtifactDigests', id: artifactId },
      ],
    }),
  }),
});

export const {
  useGetArtifactDigestQuery,
  useRegenerateArtifactDigestMutation,
  useGetArtifactFactsQuery,
  useGetMentionedProvidersQuery,
  useGetArtifactReferencesQuery,
} = artifactDigestApiClient;
